import React from 'react';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { PencilSquareIcon as PencilAlt } from '@heroicons/react/24/outline';
import useAutoSuggestGroupContext from '@teetsh/app/src/components/Form/AutoSuggestGroup/useAutoSuggestGroupContext';
import { useField } from 'react-final-form';
import { updateNotesWithNewReferentialItem } from './updateNotesWithNewReferentialItem';
import { Note } from '../types/carnetsDeNotes';
import { useDeleteNotesWarningModal } from './DeleteNotesWarningModal/useDeleteNotesWarningModal';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { useTranslation } from 'react-i18next';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

interface Props {
  eleves: Eleve[];
  evaluationId: string;
  notationSystem?: NotationSystem;
}

export function RankThisItemButton(props: Props) {
  const { eleves, evaluationId, notationSystem } = props;
  const notesField = useField<Note[]>('notes');
  const { t } = useTranslation(['carnet']);
  const { open } = useDeleteNotesWarningModal();
  const {
    input: { value, onChange },
  } = notesField;
  const { item } = useAutoSuggestGroupContext();
  return (
    <Tooltip2 label={t('carnet:evaluationForm.actions.rankSeparately')}>
      <Button
        active={value.filter(n => n.referentialItemId === item?.id).length > 0}
        minimal
        icon={PencilAlt}
        aria-label={`Noter séparément ${item?.value}`}
        onClick={() => {
          if (item?.id) {
            const { newNotes, areSomeNotesDeleted } =
              updateNotesWithNewReferentialItem(
                value,
                eleves,
                item.id,
                evaluationId,
                notationSystem,
              );
            if (areSomeNotesDeleted) {
              const callback = () => onChange(newNotes);
              open({ callback });
            } else {
              onChange(newNotes);
            }
          }
        }}
      />
    </Tooltip2>
  );
}
